import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ShiftPlanner } from "../../../../../Actions/commonAction";
import viewMetaData from "./ViewMetaData";

let viewModeElement = [];
const generateElement = (objElement, values) => (
  <div>
    <p className={objElement.headercss}>{objElement.header}</p>
    <p className={objElement.subheadercss}>{objElement.subheader}</p>

    {objElement.header == "Color Code" ? (
      <div className="cursour-pointer list-tabel">
        <div
          className="shiftcolor-large floatleft"
          style={{ background: values, marginRight: 10, marginBottom: 9 }}
        />
        <span>{values}</span>
      </div>
    ) : (
      <p style={{ textAlign: "justify" }}>
        {values}
        {/* <span
          style={{
            backgroundColor: values,
            height: "20px",
            width: "20px",
            marginLeft: "16px",
          }}
        ></span> */}
      </p>
    )}
  </div>
);
function generateData(metaObj, viewData) {
  let dynamicVal = "";
  let jsonVal = "";
  let isValidobj = true;
  if (metaObj != undefined) {
    Object.keys(metaObj).map((result) => {
      isValidobj = true;
      if (Array.isArray(metaObj[result])) {
        generateData(metaObj[result], viewData[result]);
      } else if (viewData[result] != undefined) {
        if (
          typeof viewData[result] === "string" ||
          typeof viewData[result] === "boolean" ||
          typeof viewData[result] === "number"
        ) {
          if (typeof viewData[result] === "boolean") {
            dynamicVal = viewData[result] ? "Yes" : "No";
            if (dynamicVal == "No") {
              isValidobj = false;
            }
          } else {
            dynamicVal = viewData[result];
            if (result == "shiftbegintime" || result == "shiftendtime") {
              if (dynamicVal == null || dynamicVal == "0" || dynamicVal == 0) {
                isValidobj = false;
              }

              // dynamicVal= moment(viewData[result]).format('h:mm A');
              const timeString = viewData[result];
              const H = +timeString.substr(0, 2);
              const h = H % 12 || 12;
              const ampm = H < 12 ? "AM" : "PM";
              dynamicVal = h + dynamicVal.substr(2, 3) + ampm;
            }
            // if(dynamicVal==null || dynamicVal=="0" || dynamicVal==0 || dynamicVal=="")
            // {
            //     isValidobj=false;
            // }
          }
          jsonVal = metaObj[result].values;
          jsonVal = jsonVal.replace("<val>", dynamicVal);

          if (isValidobj) {
            const nested = generateElement(metaObj[result], jsonVal);
            viewModeElement.push(nested);
          }
          // return nested;
        } else {
          generateData(metaObj[result], viewData[result]);
        }
      } else {
        jsonVal = "";
        const nested = generateElement(metaObj[result], jsonVal);
        // return nested;
        viewModeElement.push(nested);
      }

      return viewModeElement;
    });

    return viewModeElement;
  }
}

class Preview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shiftPlannerReducer: {},
      Metadata: {},
      elementList: [],
    };
  }

  componentDidMount() {
    const { shiftPlannerReducer } = this.props;
    const viewmodejson = viewMetaData;
    viewModeElement = [];
    const elementArray = generateData(viewmodejson, shiftPlannerReducer);

    this.setState({
      shiftPlannerReducer,
      Metadata: viewmodejson,
      elementList: elementArray,
    });

    this.props.onRef({
      onNext: this.OnSave,
    });
  }

  OnSave = () => {
    this.props.OnSave();
    // this.props.FinalSave(true);
    // this.OnNext()
  };

  OnCancel() {
    this.props.Cancel(true);
  }

  render() {
    const language = this.props.Language.allshiftplanner;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="padding-30 ">
          <div className="inner-wrapper opaque">{this.state.elementList}</div>
        </div>
      </IntlProvider>
    );
  }
}

Preview.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  shiftPlannerReducer: state.shiftPlannerReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ShiftPlanner: (data) => ShiftPlanner(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(Preview));
